/** Generic success envelope returned by the BizPandit API. */
export interface ApiResponse<T> {
  data: T;
  message?: string;
}

/** Generic paginated envelope. */
export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

/** Normalized error shape thrown by the axios response interceptor. */
export interface ApiError {
  status: number;
  message: string;
  code?: string;
  fieldErrors?: Record<string, string[]>;
}

/**
 * Runtime guard for the normalized ApiError shape. Narrows an unknown/Error
 * value to ApiError only when it actually carries the required `status`
 * property, so callers can safely read `error.status` without an unsafe cast.
 */
export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    typeof (error as { status: unknown }).status === "number"
  );
}

export interface PaginationParams {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}
